// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"792":"main","877":"sample"}[chunkId] || chunkId) + "." + {"179":"8045f991","234":"690d2a86","792":"f5e25c74","877":"ab70781d"}[chunkId] + ".js";
};